
import React from 'react';

import { Typography, Grid, Button, Box, Container } from "@mui/material";

import LEFTIMAGE from '../../assets/IFW_SoftwareCHARTS-06.png'
import RIGHTIMAGE from '../../assets/IFW_SoftwareCHARTS-01.png'


const VolatilityChart = () => {
    const chartTitleStyle = { color: 'grey', fontWeight: 'bold', fontSize: '18px', margin: '0.2em' }



    return (
        <Grid>
            <Box xs={10} ml={6} mt={1} style={{ display: 'flex', flexDirection: 'row', marginLeft: '10%' }}  >
                <Typography style={chartTitleStyle}> DON’T WITHDRAW MONEY DURING MARKET DOWN YEARS  </Typography>
            </Box>
            <Grid container mt={2} justifyContent={'center'} >
                <Grid item xs={5} mr={1}>
                    <img src={RIGHTIMAGE} style={{ width: '100%', height: '95%', objectFit: 'fill' }} />
                </Grid>
                <Grid item xs={5} ml={1} >
                    <img src={LEFTIMAGE} style={{ width: '100%', height: '95%', objectFit: 'fill' }} />
                </Grid>
                <Grid style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column' }}>
                    <Typography style={{ ...chartTitleStyle, fontSize: '1.0vw', margin: 0 }}>
                        Action: Access Money from the Volatility Buffer (safe bucket) when the growth bucket is down.</Typography>
                    <Typography style={{ ...chartTitleStyle, fontSize: '1.0vw', color: '#157ee8', textDecoration: 'underline', cursor: 'pointer', margin: 0 }}>
                        End Result: Your Portfolio Has Time To Recover Lowering Your Risk Of Running Out Of Money</Typography>
                </Grid>
            </Grid>

        </Grid>)
}

export default VolatilityChart;